import { useEffect } from "react"
import { useRouter } from "next/router"
import Head from "next/head"
import "@fontsource/montserrat"
import "@fontsource/montserrat/700.css"

import "styles.css"

import PreviewAlert from "components/PreviewAlert"
import Header from "components/Header"
import Footer from "components/Footer"
import FirstTimeEntryModal from "components/FirstTimeEntryModal"

import useStoryblok from "storyblok/useStoryblok"
import { DogtownLocationsProvider } from "context/dogtownLocations"

const ATTRIBUTION_KEY = "dogtown.attribution"

function isAttributionParam(name) {
  const key = name.toLowerCase()

  return key.startsWith("utm_") || key.endsWith("clid") || key === "msclkid" || key === "gbraid" || key === "wbraid"
}

function saveAttributionParams() {
  const params = new URLSearchParams(window.location.search)
  const attribution = new URLSearchParams()

  params.forEach((value, key) => {
    if (isAttributionParam(key)) {
      attribution.append(key, value)
    }
  })

  if (attribution.toString()) {
    localStorage.setItem(ATTRIBUTION_KEY, attribution.toString())
  }
}

function restoreAttributionParams() {
  if (!window.location.pathname.endsWith("/enroll")) return

  const stored = localStorage.getItem(ATTRIBUTION_KEY)

  if (!stored) return

  const currentParams = new URLSearchParams(window.location.search)
  const storedParams = new URLSearchParams(stored)

  storedParams.forEach((value, key) => {
    if (!currentParams.has(key)) {
      currentParams.set(key, value)
    }
  })

  const newUrl = window.location.pathname + `?${currentParams.toString()}` + window.location.hash

  window.history.replaceState(window.history.state, "", newUrl)
}

function MyApp({ Component, pageProps: { preview, story, resolve_relations, globals, ...remainingProps } }) {
  story = useStoryblok({ story, resolve_relations })

  const router = useRouter()

  useEffect(() => {
    const handleRoute = () => {
      saveAttributionParams()
      restoreAttributionParams()
    }

    handleRoute()

    router.events.on("routeChangeComplete", handleRoute)

    return () => {
      router.events.off("routeChangeComplete", handleRoute)
    }
  }, [router.events])

  return (
    <>
      <Head>
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
        <link rel="manifest" href="/favicon/site.webmanifest" />
        <link rel="mask-icon" href="/favicon/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#603cba" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="facebook-domain-verification" content="kt2apj8ipn1q4dohhoa64cp6htrppc" />
      </Head>
      {/* <FirstTimeEntryModal /> */}

      {preview && <PreviewAlert />}
      <DogtownLocationsProvider buildData={globals.locationData}>
        <Header {...globals.header} />
        <Component story={story} {...remainingProps} />
        <Footer {...globals.footer} />
      </DogtownLocationsProvider>
    </>
  )
}

export default MyApp
